import React from 'react';
import { Row, Col, Card, CardBody, CardText } from 'reactstrap';
import IntlMessage from '../../../../helpers/intlMessage';

const AnexoPage = (props) => (
  <Col
    style={{
      height: props.alturaEditor(),
      overflowY: 'auto',
      overflowX: 'hidden',
    }}
    className='mv-anexo-container espacamento-container-lateral'
  >
    {props.listagem.length === 0 && (
      <p className='mv-semItem'><IntlMessage id = "dashboards.examDetail.noAttachmentsRegistered"/></p>
    )}
    {props.listagem.map((anexo) => (
      <Row key={anexo.id}>
        <Col>
          <Card style={{ marginBottom: 0 }}>
            <CardBody>
              <CardText
                onClick={() =>
                  props.download(anexo.id, anexo.nomeArquivo, anexo.extensao)
                }
              >
                <i className='fas fa-search-plus fa-1x'></i> {anexo.descricao}
              </CardText>
            </CardBody>
          </Card>
        </Col>
      </Row>
    ))}
  </Col>
);

export default AnexoPage;



// WEBPACK FOOTER //
// ./src/app/common/tabs/anexo/anexo.page.js